const shipmentBookingStatus = {
  draft: 'Draft',
  submitted: 'Submitted',
};

export default shipmentBookingStatus;
